<template>
    <modal title="Newsletter">
        <div v-if="!active">
            Melde dich zum Wüstenrot Newsletter an und erhalte so immer die
            neuesten Informationen von uns.
            <ion-button
                expand="block"
                class="ion-margin-top"
                @click="activate()"
                >Abonnieren</ion-button
            >
        </div>
        <ion-button
            v-else
            expand="block"
            class="ion-margin-top"
            @click="deactivate()"
            >Abbestellen</ion-button
        >
        <template v-slot:footer>
            <ion-button
                expand="block"
                fill="outline"
                @click="$ionic.modalController.dismiss()"
                >Schließen</ion-button
            >
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
import {
    newsletterGetStatus,
    newsletterActivate,
    newsletterDeactivate,
} from "@/api/newsletter";

export default {
    components: {
        Modal,
    },
    props: {},
    data() {
        return {
            active: false,
        };
    },
    mounted() {
        this.$store.commit("setLoading", true);
        newsletterGetStatus().then((response) => {
            if (response.data.Status === 200) {
                this.active = response.data.Result.Active;
            }
        });
    },
    methods: {
        activate() {
            this.$store.commit("setLoading", true);
            newsletterActivate().then((response) => {
                if (response.data.Status === 200) {
                    this.active = true;
                }
            });
        },
        deactivate() {
            this.$store.commit("setLoading", true);
            newsletterDeactivate().then((response) => {
                if (response.data.Status === 200) {
                    this.active = false;
                }
            });
        },
    },
};
</script>

<style></style>
